export default __webpack_public_path__ + "static/media/icon_monitor.88a4c2c1.svg";